import React, { createContext, useContext } from 'react'

import { FilterOption } from '../types/feedbackGrid.types'

interface FeedbackGridContextType {
	translations: Record<string, string>
	filterOptions: Record<string, FilterOption[]>
	loadingOptions: Record<string, boolean>
	loadFilterOptions: (field: string) => Promise<void>
}

const FeedbackGridContext = createContext<FeedbackGridContextType | undefined>(undefined)

export const FeedbackGridProvider: React.FC<{
	value: FeedbackGridContextType
	children: React.ReactNode
}> = ({ value, children }) => {
	return <FeedbackGridContext.Provider value={value}>{children}</FeedbackGridContext.Provider>
}

export const useFeedbackGridContext = () => {
	const context = useContext(FeedbackGridContext)
	if (context === undefined) {
		throw new Error('useFeedbackGridContext must be used within a FeedbackGridProvider')
	}
	return context
}
